import React from 'react'
import { IconSearch } from '../icons'
import { SearchProps } from './index'
import { useTranslation } from 'react-i18next'

const Search: React.FC<SearchProps> = ({ toSearch }) => {
  const { t } = useTranslation()
  return (
    <div className="relative rounded-control w-full">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
        <IconSearch size={18} />
      </div>
      <input
        className="block bg-input w-full h-11 leading-7 rounded-control border border-border pl-10 text-foreground placeholder:leading-7 focus-visible:outline-none focus-visible:border-primary placeholder:text-muted-foreground text-sm font-medium"
        type="text"
        placeholder={t('searchByName')}
        onChange={(event) => toSearch(event.target.value)}
      />
    </div>
  )
}

export default Search
